import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalAccountsFreshnessQuery = graphql(`
  query ClientPortalAccountsFreshness($id: ID!, $householdId: ID) {
    portfolio(userId: $id, householdId: $householdId) {
      id
      accounts {
        id
        firmName
        hiddenFromClient
        providerAccount {
          id
          providerName
          source
          freshness {
            syncStatus
            lastSyncedAt
            linkStatus
            disconnected
            reconnectSupported
          }
        }
      }
      clientProfile {
        id
        providerAccounts {
          id
          providerName
          source
          freshness {
            syncStatus
            lastSyncedAt
            linkStatus
            disconnected
            reconnectSupported
          }
        }
      }
    }
  }
`);

export type ClientPortalAccountsFreshnessResult = ResultOf<typeof ClientPortalAccountsFreshnessQuery>;
